module.exports = __webpack_public_path__ + "img/type2_bg3.15deb745.png";